import { Modal } from 'components'
import { ReactElement, ReactNode, useState } from 'react'

interface IDeleteModalProps {
  onConfirm(): void
  children?: ReactNode
}

const useDeleteModal = ({
  onConfirm,
  children,
}: IDeleteModalProps): [ReactElement, VoidFunction] => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const handleConfirm = () => {
    onConfirm()
    setIsOpen(false)
  }

  return [
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title="Attention!"
      onConfirm={handleConfirm}
      onConfirmButtonText="Ok"
    >
      {children}
    </Modal>,
    () => setIsOpen(!isOpen),
  ]
}

export default useDeleteModal
